import stringify from 'json-stable-stringify';

export function deepSort<T>(obj: T): T {
  return JSON.parse(stringify(obj)) as T;
}
